module.exports = __webpack_public_path__ + "sd.svg?d1da0e6279e78a54ee0e671df4c1b0c4";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sd.svg
// module id = 1122
// module chunks = 27